import React,{useEffect,useState} from 'react'
import './BreadCrumb.scss';
const BreadCrumb = ({path=[]}) => {
  return (
    <>
    {path.length!=0&&
    <div className='bredcrumb-section'>
        {path.map((pathname,index)=>{
            return <>
            <span className={(index!=(path.length-1))?'bread-crumb':'bread-crumb active'}>{pathname}</span>{(index!=(path.length-1))&&<>/</>}
            </> 
        })}
    </div>}
    </>
  )
}

export default BreadCrumb